import React, { forwardRef } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import AlertContainer from './AlertContainer/AlertContainer.js'
import Styles from './ChargePointsContainer.module.css'
import RequestState from 'Enums/RequestState'
import { Colors } from 'Theme'
import { IFText, IFSkeleton } from 'Components'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const ListContainer = styled.div`
  box-shadow: 0px 0px 2px 0px ${Colors.ChargePointSpecsListContainerShadow};
  border-radius: 0px 0px 5px 5px;
  padding-top: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
`

const ChargePointsContainer = forwardRef(
  (
    {
      isEditing,
      maxListHeight,
      style,
      scrollbarsHeight,
      onModalSubmit = () => {},
      displayedList,
    },
    ref,
  ) => {
    const { t } = useTranslation()

    const isLoading = () => {
      return false
    }

    return (
      <ListContainer>
        <div
          className={Styles.ChargePointsContainer}
          {...(style ? { style: style } : {})}
        >
          <div
            className={Styles.ChargePointListHeader}
            style={isEditing ? {} : { paddingRight: '1rem' }}
          >
            <div>
              {isLoading() ? (
                <IFSkeleton variant="text" width="5rem" height="1.5rem" />
              ) : (
                <IFText
                  className={Styles.HeaderText}
                  style={{ color: Colors.text }}
                >
                  {t('ChargePointList.ChargePointName')}
                </IFText>
              )}
            </div>
            <div>
              {isLoading() ? (
                <div>
                  <IFSkeleton variant="text" width="4rem" height="1.5rem" />
                </div>
              ) : null}
            </div>
          </div>

          <AlertContainer
            ref={ref}
            isEditing={isEditing}
            maxListHeight={maxListHeight}
            scrollbarsHeight={scrollbarsHeight}
            displayedList={displayedList}
            onSubmit={onModalSubmit}
          />
        </div>
      </ListContainer>
    )
  },
)

ChargePointsContainer.propTypes = {
  isEditing: PropTypes.bool,
  maxListHeight: PropTypes.number,
  style: PropTypes.object,
  scrollbarsHeight: PropTypes.string,
  onModalSubmit: PropTypes.func,
}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, null, null, {
  forwardRef: true,
})(ChargePointsContainer)
